import { render } from "./FormCheckboxGroup.vue?vue&type=template&id=6438c3b1&scoped=true&ts=true"
import script from "./FormCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./FormCheckboxGroup.vue?vue&type=script&lang=ts"

import "./FormCheckboxGroup.vue?vue&type=style&index=0&id=6438c3b1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6438c3b1"]])

export default __exports__